import mixpanel from "mixpanel-browser";
import { isProductionEnv, mixpanelToken } from "utils/envs";

mixpanel.init(mixpanelToken, { debug: true, test: true });

const useMixPanel = (isAdmin) => {
  const hasActions = isAdmin !== undefined && (!isProductionEnv || !isAdmin);

  const identify = (id) => {
    if (hasActions) mixpanel.identify(id);
  };

  const people = {
    set: (props) => {
      if (hasActions) mixpanel.people.set(props);
    },
  };

  const register = (props) => {
    if (hasActions) mixpanel.register(props);
  };

  const track = (name, props) => {
    if (hasActions) mixpanel.track(name, { ...props, page: window.location.pathname.replace('/', '') });
  };

  return {
    identify,
    people,
    register,
    track,
  };
};

export default useMixPanel;
